import { computed, inject, Injectable, resource } from '@angular/core';
import { JsonHttpService } from '../../http/json-http.service';
import { TimeZoneMetaData } from '../models/time-zone-meta-data';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TimeZoneService {

    private httpService = inject(JsonHttpService);

    private timeZonesResource = resource({
            params: () => ({}),
            loader: () => this.getAll()
        });
    timeZones = computed(() => this.timeZonesResource.value() ?? []);

    private localTimeZoneResource = resource({
            params: () => ({}),
            loader: () => this.getLocal()
        });
    localTimeZone = computed(() => this.localTimeZoneResource.value() ?? null);

    private async getAll() : Promise<TimeZoneMetaData[]>{
        return await firstValueFrom(this.httpService.getTyped<TimeZoneMetaData[]>('/api/globalization/time-zones/get-all-time-zones', null));
    }

    private async getLocal() : Promise<TimeZoneMetaData>{
        return await firstValueFrom(this.httpService.getTyped<TimeZoneMetaData>('/api/globalization/time-zones/get-local-time-zone', null));
    }
}
